import { CheckCircle, Heart } from 'lucide-react';
import React, { useState, useEffect, useCallback } from 'react';
import '../styles/thankyou.css'; // Import your CSS styles for the animation
const ThankYouAnimation = ({ isVisible, onClose }) => {
  const [showContent, setShowContent] = useState(false);

  const handleClose = useCallback(() => {
    setShowContent(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (isVisible) {
      setShowContent(true);

      // Auto close after 4 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, handleClose]);

  if (!isVisible) return null;

  return (
    <div className="overlay">
 

      {/* Main Animation Container */}
      <div className={`card border-0 shadow-lg text-center main-container ${showContent ? 'show' : ''}`}>
        <div className="card-body p-4 p-md-5">
          {/* Success Icon with Pulse Animation */}
          <div className="success-icon-wrapper mb-4 d-flex justify-content-center">
            <div className="ping-bg"></div>
            <div className="success-icon">
              <CheckCircle className="text-white bounce-icon" size={40} />
            </div>
          </div>

          {/* Thank You Text with Animation */}
          <div className="mb-4">
            <h2 className="h1 fw-bold text-dark pulse-text mb-3">
              Thank You! 🎉
            </h2>
            <p className="lead text-muted mb-2">
              Your inquiry has been submitted successfully!
            </p>
            <p className="text-secondary">
              We'll get back to you within 24 hours.
            </p>
          </div>

          {/* Heart Animation */}
          <div className="d-flex justify-content-center gap-2 mb-4">
            {[0, 1, 2].map((i) => (
              <Heart
                key={i}
                className="text-danger pulse-heart"
                size={24}
                fill="currentColor"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="mb-4">
            <div className="progress mb-2" style={{ height: '8px' }}>
              <div
                className="progress-bar progress-bar-animated w-100"
                role="progressbar"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <small className="text-muted">Closing automatically...</small>
          </div>

          {/* Close Button */}
          <button
            onClick={handleClose}
            className="btn btn-primary btn-lg btn-hover px-4 rounded-pill"
            type="button"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );

}
export default ThankYouAnimation;